import React, {Component} from 'react';
import {SortableElement} from "react-sortable-hoc";
import SortableChaptersContainer from '../../containers/AdminPanel/SortableChaptersContainer';
import $ from 'jquery';
import CountUp from 'react-countup';
import moment from 'moment';

class SortableChapterItem extends Component {
    render(){
        let QuestionCount = 0;
        let targetFinish = "";

        if(this.props.item.type == "test"){
            this.props.item.sections.map(s => {
                if(s.subSections){
                    s.subSections.map(sub => {
                        QuestionCount += sub.questions.length;
                    })
                }
                
            })

            let test = this.props.item;

            if(test.finish >= 3660){
                targetFinish = moment.utc(test.finish*1000).format('HH:mm:ss');
            }else if(test.finish >= 60){
                targetFinish = moment.utc(test.finish*1000).format('mm:ss');
            }else{
                targetFinish = moment.utc(test.finish*1000).format('mm:ss');
            }
        }




        return (
            <div
                key={`chapter_${this.props.index}`}
                className="panel customPanel"
            >
                <div className="panel-heading dark-panel-header bg-gray">
                    <div className="panel-control">

                        <div className="btn-group">
                            <button
                                data-toggle="dropdown"
                                className="dropdown-toggle btn btn-info btn-no-bg-i"
                                aria-expanded="false"
                            >
                                <i className="zmdi zmdi-chevron-down padding-rgt"/>
                                Options
                            </button>
                            {this.props.item.type == "test" ?
                                <ul className="dropdown-menu chapter-dropdown dropdown-menu-right">
                                    <li>
                                        <button
                                            onClick={(e) => {
                                                window.location.href = '/tests/' + this.props.item.id
                                            }}
                                        >
                                            <i className="zmdi zmdi-plus-circle"/>
                                            &nbsp; Edit Test
                                        </button>
                                    </li>

                                    <li>
                                        <button


                                            onClick={(e) => {

                                                e.preventDefault();
                                                this.props.deleteChapterConfirmation(this.props.item);

                                            }}
                                        >
                                            <i className="zmdi zmdi-delete"/>
                                            &nbsp; Delete This Test
                                        </button>
                                    </li>

                                </ul>

                            :
                                <ul className="dropdown-menu chapter-dropdown dropdown-menu-right">
                                    <li>
                                        <button
                                            onClick={(e) => {
                                                e.preventDefault();
                                                window.location.href = '/add-lecture/' + this.props.item.courseId + "/" + this.props.item.courseSubjectId + "/" + this.props.item.id + "/" + this.props.item.ChapterVideo.length;
                                            }}
                                        >
                                            <i className="zmdi zmdi-plus-circle"/>
                                            &nbsp; Add Lecture
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.props.addTest(this.props.item.courseId, this.props.item.courseSubjectId, this.props.item.id, this.props.item.ChapterVideo.length);
                                                //window.location.href = '/add-lecture/' + this.props.item.courseId + "/" + this.props.item.courseSubjectId + "/" + this.props.item.id + "/" + this.props.item.ChapterVideo.length;
                                            }}
                                        >
                                            <i className="zmdi zmdi-plus-circle"/>
                                            &nbsp; Add Test
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            onClick={() => {
                                                this.props.editChapter(this.props.item);
                                                /*

                                                this.setState({
                                                    editChapterModal: true,
                                                    chapter: item
                                                })
                                                 */
                                            }

                                            }
                                        >
                                            <i className="zmdi zmdi-edit"/>
                                            &nbsp; Edit Chapter Info
                                        </button>
                                    </li>
                                    <li>
                                        <button


                                            onClick={(e) => {

                                                e.preventDefault();
                                                this.props.deleteChapterConfirmation(this.props.item);

                                            }}
                                        >
                                            <i className="zmdi zmdi-delete"/>
                                            &nbsp; Delete This Chapter
                                        </button>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <i className="zmdi zmdi-upload"/>
                                            &nbsp; Upload PDF
                                        </a>
                                    </li>
                                </ul>
                            }

                        </div>
                    </div>
                    <h3 className="panel-title">
                            <span className="font-18 font-400 text-uppercase">
                                {this.props.numberIndex + 1}. {this.props.item.type === 'test' ? 'Test' : this.props.item.name}
                            </span>
                    </h3>
                </div>

                {this.props.item.type == "test" &&


                    <div
                    id={"panel_chapter_part_test_" + this.props.item.number}
                    className="chapter-part"
                    >
                    <div className="row no-margin">
                    <div className="col-sm-5 no-padding">
                    <div
                    style={{borderBottom: "1px solid #f1f1f1"}}
                    >
                    <div className="chapter_info">
                    <div className="chapter_thumb">
                    <img src={''} />
                    </div>
                    <div className="chapter_desc">
                    <h3 className="font-18 sm-top0">
                    {this.props.item.name || 'Untitled Test'}
                    </h3>
                    <div className="chapter_controls">
                    <div className="font-16">


                    </div>
                    </div>
                    </div>
                    </div>
                    </div>
                    </div>
                    <div className="col-sm-7 no-padding">
                    <div className="row">
                        <div className="col-sm-3">
                            <div className="head-subhead">
                                <p>Target Time</p>
                                <h3>
                                    {targetFinish}
                                </h3>
                            </div>
                        </div>
                    <div className="col-sm-3">
                    <div className="head-subhead">
                    <p>Sections</p>
                    <h3>
                        <CountUp
                            className="counter"
                            start={0}
                            end={this.props.item.sections.length}
                            duration={3.75}
                        />
                    </h3>
                    </div>
                    </div>
                    <div className="col-sm-3">
                    <div className="head-subhead">
                    <p>Total Questions</p>
                    <h3>
                        <CountUp
                            className="counter"
                            start={0}
                            end={QuestionCount}
                            duration={3.75}
                        />
                    </h3>
                    </div>
                    </div>

                    <div className="col-sm-3">
                    <div className="head-subhead">
                        <p>Status</p>
                    <h3>
                    <span>
                        <select
                            className="form-control status-select"
                            value={this.props.item.status}
                            onChange={(e) => {

                                this.props.updateChapterStatus(this.props.item.id, e.target.value);
                            }}>
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                        </select>


                    </span>
                    </h3>
                    </div>
                    </div>
                    </div>
                    </div>
                    </div>

                    </div>
                    }
                <SortableChaptersContainer
                    parts={this.props.item.ChapterVideo}
                    redirect={this.redirect}
                    number={this.props.index}
                    reorderChapterParts={this.props.reorderChapterParts}
                    user={this.props.user}
                    item={this.props.item}
                    updateChapterPartStatus={this.props.updateChapterPartStatus}
                     history={this.props.history}
                />
            </div>

        )
    }
}

export default SortableElement(SortableChapterItem);


// WEBPACK FOOTER //
// ./src/components/AdminPanel/SortableChapterItem.js